export default __webpack_public_path__ + "static/media/1-05.f44e9292.png";